import CustomSelectField from 'components/forms/customSelectField/CustomSelectField';
import { SeasonalRuleColor } from 'models/seasonality/SeasonalRule';
import { useTranslation } from 'react-i18next';
import { normalizeKey } from 'utils/localeUtils';
import { ColorDot } from '../../../table/SeasonalRulesTable.styles';
import { ColorOptionStyled } from '../SeasonalRuleAddEditModal.styles';

const ColorField = () => {
  const { t } = useTranslation();

  const options = Object.values(SeasonalRuleColor).map((color) => ({
    value: color,
    label: (
      <ColorOptionStyled>
        <ColorDot $color={color} />
        <span>
          {t(normalizeKey(`pageProperty.seasonality.colors.${color}`))}
        </span>
      </ColorOptionStyled>
    ),
  }));

  return (
    <CustomSelectField
      label={t('pageProperty.seasonality.modal.fields.color.label')}
      labelTooltip={t('pageProperty.seasonality.modal.fields.color.tooltip')}
      name="color"
      labelOnTop
      placeholder={t('pageProperty.seasonality.modal.fields.color.placeholder')}
      options={options}
      isSearchable={false}
      isClearable={false}
      colSmLabel={12}
      colSmInput={12}
      required
    />
  );
};

export default ColorField;
